module.exports = __webpack_public_path__ + "img/truc5.578b7020.png";